/**
 * Item 1 (19/10) — paginação dos relatórios grandes.
 *
 * O backend só pagina quando recebe ?page (responde {items, total, page, total_pages}); sem ?page
 * responde o formato antigo (lista, ou objeto com items). Assim o bundle antigo e o backend antigo
 * continuam funcionando: a tela sempre manda ?page e aceita as duas respostas.
 */
export const PAGE_SIZE_RELATORIO = 50;

/** Acrescenta page/page_size à URL (com ou sem query string). */
export function comPagina(url, page = 1, pageSize = PAGE_SIZE_RELATORIO) {
  const base = String(url || "");
  const sep = !base.includes("?") ? "?" : (base.endsWith("?") || base.endsWith("&") ? "" : "&");
  return `${base}${sep}page=${Math.max(1, Number(page) || 1)}&page_size=${pageSize}`;
}

/**
 * Normaliza a resposta para {items, total, page, total_pages, legado}.
 * - lista (backend antigo / rota sem paginação): tudo numa página só, legado=true;
 * - {items, total_pages, ...}: paginada pelo servidor, legado=false;
 * - {items, ...} sem total_pages (formato antigo de objeto): uma página só, legado=true.
 * Campos extras do objeto (ex.: inicio, fim, min_abast, totais) são preservados.
 */
export function normalizaPaginado(data, pagina = 1) {
  if (Array.isArray(data)) {
    return { items: data, total: data.length, page: 1, total_pages: data.length ? 1 : 0, legado: true };
  }
  if (data && Array.isArray(data.items)) {
    if (data.total_pages != null) {
      const total = Number(data.total ?? data.total_registros ?? data.items.length) || 0;
      return {
        ...data,
        items: data.items,
        total,
        page: Number(data.page) || Number(pagina) || 1,
        total_pages: Number(data.total_pages) || 0,
        legado: false,
      };
    }
    const total = Number(data.total ?? data.total_registros ?? data.items.length) || 0;
    return { ...data, items: data.items, total, page: 1, total_pages: data.items.length ? 1 : 0, legado: true };
  }
  return { items: [], total: 0, page: 1, total_pages: 0, legado: true };
}
